import _ from 'lodash'

import { Input, Textarea, Select, LegacyPage, Form } from 'peach/components'
import { humanizeKey } from 'peach/helpers'

const methods = ['get', 'post', 'put', 'patch', 'delete']

const methodOptions = _.map(methods, (method) => ({
  label: method.toUpperCase(),
  value: method,
}))

const ApiCallForm = ({ value, onChange, pathArgsList }) => {
  const { method, pathArgs } = value || {}

  const onPathArgChange = (key, val) => {
    onChange({ ...value, pathArgs: { ...pathArgs, [key]: val } })
  }

  const hasBody = _.includes(['post', 'put', 'patch'], method)
  return (
    <LegacyPage.Full>
      <Form.Provider onChange={onChange} value={value}>
        <Select formKey='method' options={methodOptions} />
        {_.map(pathArgsList, (argKey) => {
          const value = pathArgs[argKey]
          const onChange = (val) => onPathArgChange(argKey, val)
          return (
            <Input
              key={argKey}
              label={humanizeKey(argKey)}
              onChange={onChange}
              value={value}
            />
          )
        })}
        <Textarea.Json formKey='queryParams' />
        {hasBody && <Textarea.Json formKey='body' />}
      </Form.Provider>
    </LegacyPage.Full>
  )
}

export default ApiCallForm
